module.exports = __webpack_public_path__ + "img/help-icon-active.1139a584.svg";